<template>
    <Fragment>
        <Portal to="header-actions">
            <AntButton
                class="mr-2"
                icon="export"
                @click="exportMeasure"
            >
                {{ $t('export') }}
            </AntButton>
            <ConfirmDangerousAction @confirm="deleteMeasure">
                <AntButton
                    class="mr-2"
                    :icon="measure.archivedAt ? 'redo' : 'delete'"
                >
                    {{ $t(measure.archivedAt ? 'unarchive' : 'archive') }}
                </AntButton>
            </ConfirmDangerousAction>
            <AntDropdown>
                <AntMenu
                    slot="overlay"
                >
                    <AntMenuItem
                        v-if="!isConcept(measure)"
                        key="1"
                        @click="$refs.customerAccessDrawer.show()"
                    >
                        <AntIcon type="lock" /> {{ $t('customerAccess') }}
                    </AntMenuItem>
                    <AntMenuItem
                        key="2"
                        @click="$refs.pricingDrawer.show()"
                    >
                        <AntIcon type="euro" /> {{ $t('pricing') }}
                    </AntMenuItem>
                    <AntMenuItem
                        v-if="isConcept(measure)"
                        key="3"
                    >
                        <ConfirmDangerousAction
                            type="primary"
                            :ok-text="$t('publishForTesting')"
                            @confirm="publishMeasure"
                        >
                            <AntIcon type="experiment" /> {{ $t('publishForTesting') }}
                        </ConfirmDangerousAction>
                    </AntMenuItem>
                    <AntMenuItem
                        v-if="isTesting(measure)"
                        key="3"
                    >
                        <ConfirmDangerousAction
                            type="primary"
                            :ok-text="$t('recommendMeasure')"
                            @confirm="recommendMeasure"
                        >
                            <AntIcon type="smile" /> {{ $t('recommendMeasure') }}
                        </ConfirmDangerousAction>
                    </AntMenuItem>
                    <AntMenuItem
                        v-if="isRecommended(measure)"
                        key="3"
                    >
                        <ConfirmDangerousAction
                            :ok-text="$t('retireMeasure')"
                            @confirm="retireMeasure"
                        >
                            <AntIcon type="frown" /> {{ $t('retireMeasure') }}
                        </ConfirmDangerousAction>
                    </AntMenuItem>
                </AntMenu>
                <AntButton>{{ $t('actions') }} <AntIcon type="down" /> </AntButton>
            </AntDropdown>
        </Portal>
        <Card
            class="max-w-3xl measure-card"
            :loading="loader.processing"
        >
            <Tabs :tabs="tabs">
                <General
                    slot="general"
                    :measure="measure"
                />
                <Version
                    slot="version"
                    :measure="measure"
                />
                <Meta
                    slot="meta"
                    :measure="measure"
                />
                <Cat
                    slot="CAT"
                    :measure="measure"
                />
            </Tabs>
        </Card>

        <Card
            class="mt-4"
            :loading="loader.processing"
        >
            <ItemsTable :items="measure.items" />
        </Card>

        <MeasurePricingDrawer
            ref="pricingDrawer"
            :measure="measure"
        />
        <CustomerAccessDrawer
            v-if="measure.id"
            ref="customerAccessDrawer"
            :measure-id="measure.id"
        />
    </Fragment>
</template>
<script>
import ItemsTable from '@/components/measures/ItemsTable.vue';
import Cat from '@/components/measures/Cat.vue';
import Meta from '@/components/measures/Meta.vue';
import Version from '@/components/measures/Version.vue';
import ConfirmDangerousAction from '@/components/ConfirmDangerousAction.vue';
import MeasurePricingDrawer from '@/components/measures/MeasurePricingDrawer.vue';
import General from '@/components/measures/General.vue';
import Tabs from '@/components/Tabs.vue';
import CustomerAccessDrawer from '@/components/customers/CustomerAccessDrawer';
import { Button, Dropdown, Menu, Icon } from 'ant-design-vue';
import resourceMixin from '@/mixins/resourceMixin';
import { mapState, mapActions } from 'vuex';
import { comparisons } from '@/measureStatus';

export default {
    name: 'MeasureView',
    components: {
        AntButton: Button,
        AntDropdown: Dropdown,
        AntMenu: Menu,
        AntMenuItem: Menu.Item,
        AntIcon: Icon,
        CustomerAccessDrawer,
        Tabs,
        General,
        MeasurePricingDrawer,
        ConfirmDangerousAction,
        Version,
        Meta,
        Cat,
        ItemsTable,
    },
    mixins: [resourceMixin('measures')],
    data: () => ({
        tabs: [
            'general',
            'version',
            'meta',
            'CAT',
        ],
    }),
    computed: {
        ...mapState({
            token: ({ auth: { token } }) => token,
        }),
    },
    methods: {
        ...comparisons,
        ...mapActions({
            publish: 'measures/publish',
            recommend: 'measures/recommend',
            retire: 'measures/retire',
        }),
        exportMeasure() {
            window.open(`${this.$endpoint}/measures/export/excel/${this.measure.id}?token=${this.token}`, '_blank');
        },
        onStatusChangeError(error) {
            this.$notification.error({
                message: error.id[0],
            });
        },
        onStatusChangeSuccess(message) {
            return () => this.$notification.success({ message: this.$t(message) });
        },
        publishMeasure() {
            this.publish()
                .then(this.onStatusChangeSuccess('successfullyPublishedMeasureForTesting'))
                .catch(this.onStatusChangeError);
        },
        recommendMeasure() {
            this.recommend()
                .then(this.onStatusChangeSuccess('successfullyRecommendedMeasure'))
                .catch(this.onStatusChangeError);

        },
        retireMeasure() {
            this.retire()
                .then(this.onStatusChangeSuccess('successfullyRetiredMeasure'))
                .catch(this.onStatusChangeError);
        },
    },
};
</script>

<style lang="scss">
.measure-card {
    .ant-card-body {
        padding-top: 12px;
    }
}
</style>
